<template>
  <div class="el-dialog-multi-checkbox-group">
    <el-dialog
      :close="handleClose"
      :visible.sync="dialogVisible2"
      class="dialog-center"
      custom-class="el-dialog--customize el-dialog-multi-checkbox-group"
      show-divider
      show-shadow
      title="选择货物类型"
      width="1100px"
    >
      <!--  -->
      <el-row
        style="width: 100%; border: 1px solid #f1f1f1; border-bottom: 0;color: red;"
        >提示：组多支持选择3个【一级类目】</el-row
      >
      <el-row style="width: 100%; border: 1px solid #f1f1f1; border-bottom: 0">
        <el-col
          style="
            width: 240px;
            border-right: 1px solid #f1f1f1;
            padding-left: 9px;
            height: 36px;
            line-height: 36px;
          "
        >
          一级类目
        </el-col>
        <el-col
          style="
            width: 200px;
            border-right: 1px solid #f1f1f1;
            padding-left: 9px;
            height: 36px;
            line-height: 36px;
          "
        >
          二级类目
        </el-col>
        <el-col
          style="
            width: 378px;
            padding-left: 9px;
            height: 36px;
            line-height: 36px;
          "
        >
          三级类目
        </el-col>
      </el-row>

      <container style="height: 500px; border: 1px solid #eee; border: 0">
        <div style="display: flex; width: 100%">
          <el-aside
            style="
              height: 500px;
              border-top: 1px solid #f1f1f1;
              overflow-x: hidden;
            "
            width="240px"
          >
            <el-menu style="border: 1px solid #f1f1f1; border-top: 0;">
              <div
                v-for="(item, idx) in mockData"
                :key="idx"
                :class="activeAll(item)"
                :title="item.categoryName"
                style="height: 30px; line-height: 30px; margin-left: 9px;display: flex"
              >
                <el-checkbox
                  :key="idx"
                  v-model="item.isSelected"
                  :indeterminate="item.isSelected && !item.isAll"
                  style="padding-left: 11px"
                  @change="handleCheckAllChangeFirst(item, idx)"
                >
                </el-checkbox>
                <p
                  style="color: #4a4a4a;margin-left: 15px;cursor: pointer;width: 100%"
                  @click.prevent="lookChoice(item, idx)"
                >
                  {{ item.categoryName }}
                </p>
              </div>
            </el-menu>
          </el-aside>

          <!-- 二级目录和三级目录的部分 -->
          <main style="flex: 1; height: 500px; padding: 0;overflow: auto;">
            <div
              v-for="(item2, index2) in qryCategoryByCodeTwo"
              :key="index2"
              class="check-box-tmpl"
            >
              <!-- 二级目录复选框 -->
              <el-checkbox
                :key="item2.categoryCode"
                v-model="item2.isSelected"
                :indeterminate="item2.isSelected && !item2.isAll"
                :label="item2.categoryCode"
                :title="item2.categoryName"
                class="all"
                @change="handleCheckedAll(item2, index2)"
              >
                {{ item2.categoryName }}
              </el-checkbox>
              <!-- 线 -->
              <!-- <div class="partition"></div> -->
              <!-- 三级目录复选框 -->
              <el-checkbox-group
                v-model="item2.checkList"
                :checkList="item2.checkList"
                class="child-checkbox"
                @change="handleCheckedChange(item2, index2)"
              >
                <template v-for="item3 in item2.children">
                  <el-checkbox
                    :key="item3.categoryCode"
                    :class="{
                      textHiddenCk: item2.children.length > 1
                    }"
                    :label="item3.categoryCode"
                    :title="item3.categoryName"
                    >{{ item3.categoryName }}
                  </el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
          </main>
        </div>
      </container>

      <span slot="footer">
        <el-button size="mini" type="default-mini" @click="cancel"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="determine"
          style="padding:0 15px;"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { qryMatCatery100001Tree } from "@/api/lessor-open-shop";
// import data from './data';
import { Container, Main } from "ccui";

export default {
  name: "DialogMultiCheckboxGroup",
  props: {
    dialogVisible: Boolean,
    defaultPitchOn: {
      type: Array,
      default: []
    },
    shopId: String,
    changeId: String
    // agentId: {
    //   type: String,
    //   default:
    //     "9F6FD19CCFA4A74EEA3E4B95AF093CFD469803DF46A5F8CDBEEBC96B7FC7DD4D"
    // }
  },
  components: {
    Container,
    Main
  },
  data() {
    return {
      qryCategoryByCodeTwo: [],
      dataRequestArrCode: [],
      mockData: [],
      localData: [],
      dialogVisible2: false,
      num: 1,
      flag: false
    };
  },
  watch: {
    dialogVisible(val) {
      this.dialogVisible2 = val;
      if (val) {
        console.log(0.0);

        // 显示的时候初始化数据
        this.pushData();
      }
    },
    defaultPitchOn(e) {
      console.log(this.defaultPitchOn, "默认数据");
    },
    dialogVisible2(val) {
      this.$emit("update:dialogVisible", val);
    }
  },

  mounted() {
    this.dialogVisible2 = this.dialogVisible;
    // this.pushData(); // 初始化请求所有数据
  },
  methods: {
    disabled(item) {
      if (this.qryCategoryByCodeTwo.length > 0) {
        if (
          this.qryCategoryByCodeTwo[0].parentOrderCode === item.categoryCode &&
          this.qryCategoryByCodeTwo[0].parentOrderCode
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    activeAll(item) {
      if (this.qryCategoryByCodeTwo.length > 0) {
        if (
          this.qryCategoryByCodeTwo[0].parentOrderCode === item.categoryCode &&
          this.qryCategoryByCodeTwo[0].parentOrderCode
        ) {
          return "activeAll";
        } else {
          return "";
        }
      }
    },
    lookChoice(item, inx) {
      // 切换一级类目，直接替换二三级类目数组
      if (item.isSelected) {
        // 有选中，改变选中和全选状态，循环改变二级选中和全选选中数组，三级全部选中
        // 处理完上一步直接替换二三级类目数组
        item.children.map(e => {
          let list = [];
          e.children.map(t => {
            if (t.isSelected) {
              list.push(t.categoryCode);
            }
          });
          e.checkList = list;
        });
      } else {
        item.children.map(e => {
          e.checkList = [];
          e.children.map(t => {
            t.isSelected = false;
          });
        });
      }
      let arr = JSON.parse(JSON.stringify(item.children));
      this.qryCategoryByCodeTwo = arr;
    },

    // 一级类目选哲
    handleCheckAllChangeFirst(item, idx) {
      console.log("改变了");
      if (item.isSelected) {
        // 全选，直接改变选中和全选状态，循环改变二级选中和全选选中数组，三级全部选中
        // 处理完上一步直接替换二三级类目数组
        item.isSelected = true;
        item.isAll = true;
        item.children.map(e => {
          e.isAll = true;
          e.isSelected = true;
          let list = [];
          e.children.map(t => {
            t.isSelected = true;
            list.push(t.categoryCode);
          });
          e.checkList = list;
        });
      } else {
        item.isSelected = false;
        item.isAll = false;
        item.children.map(e => {
          e.isAll = false;
          e.isSelected = false;
          e.checkList = [];
          e.children.map(t => {
            t.isSelected = false;
          });
        });
      }
      let arr = JSON.parse(JSON.stringify(item.children));
      this.qryCategoryByCodeTwo = [...arr];
      console.log(this.qryCategoryByCodeTwo, "gaibian");
    },
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
    handleCheckedAll(data, childrenOneIdx) {
      if (data.isSelected) {
        // 全部选中，循环三级类目，全部设为选中,三级类目选中数组变更为全部
        // 在循环总数据，判断一级类目是否需要全选
        data.isSelected = true;
        data.isAll = true;
        let list = [];
        data.children.map(e => {
          e.isSelected = true;
          list.push(e.categoryCode);
        });
        data.checkList = list;
        let arr2 = JSON.parse(JSON.stringify(this.mockData));
        arr2.map(i => {
          if (
            data.parentOrderCode === i.categoryCode ||
            data.parentOrderCode.slice(0, 2) === i.categoryCode
          ) {
            let num = 0;
            i.children[childrenOneIdx] = data;
            i.children.map(it => {
              if (it.isAll) {
                num++;
              }
            });
            if (num === i.children.length) {
              // 全选
              i.isAll = true;
              i.isSelected = true;
            } else if (num === 0) {
              // 全部未选中
              i.isAll = false;
              i.isSelected = false;
            } else {
              // 部分选中
              i.isAll = false;
              i.isSelected = true;
            }
          }
        });
        let arr = JSON.parse(JSON.stringify(this.qryCategoryByCodeTwo));
        arr[childrenOneIdx] = data;
        this.qryCategoryByCodeTwo = [...arr];
        this.mockData = [...arr2];
      } else {
        data.isSelected = false;
        data.isAll = false;
        data.checkList = [];
        data.children.map(e => {
          e.isSelected = false;
        });
        let arr2 = JSON.parse(JSON.stringify(this.mockData));
        arr2.map(i => {
          if (
            data.parentOrderCode === i.categoryCode ||
            data.parentOrderCode.slice(0, 2) === i.categoryCode
          ) {
            let num = 0;
            i.children[childrenOneIdx] = data;
            i.children.map(it => {
              if (it.isAll) {
                num++;
              }
            });
            if (num === i.children.length) {
              // 全选
              i.isAll = true;
              i.isSelected = true;
            } else if (num === 0) {
              // 全部未选中
              i.isAll = false;
              i.isSelected = false;
            } else {
              // 部分选中
              i.isAll = false;
              i.isSelected = true;
            }
          }
        });
        let arr = JSON.parse(JSON.stringify(this.qryCategoryByCodeTwo));
        arr[childrenOneIdx] = data;
        this.qryCategoryByCodeTwo = [...arr];
        this.mockData = [...arr2];
      }
    },

    // 三级类目选折
    handleCheckedChange(item, index) {
      console.log(item, "item....");
      console.log(item.checkList, "item.checkList//...");
      item.children.map(e => {
        if (item.checkList.indexOf(e.categoryCode) != -1) {
          e.isSelected = true;
        } else {
          e.isSelected = false;
        }
      });
      if (item.checkList.length === item.children.length) {
        item.isSelected = true;
        item.isAll = true;
      } else if (item.checkList.length === 0) {
        item.isSelected = false;
        item.isAll = false;
      } else {
        item.isSelected = true;
        item.isAll = false;
      }
      // let arr2 = JSON.parse(JSON.stringify(this.mockData));
      // arr2.map((i) => {
      this.mockData.map(i => {
        if (
          item.parentOrderCode === i.categoryCode ||
          item.parentOrderCode.slice(0, 2) === i.categoryCode
        ) {
          // 找到总数据和点击的数据对应的二级目录
          // 替换一下数据，然后循环一级目录下所有二级目录
          // 如果全选中项和总数相等，一级全选否则相反
          let num = 0;
          // num2用来记录是否有选中的二级
          let num2 = 0;
          i.children[index] = item;
          i.children.map(it => {
            if (it.isSelected && it.isAll) {
              num++;
            } else {
              if (it.isSelected) {
                num2++;
              }
            }
          });
          if (num === i.children.length) {
            // 全选
            i.isAll = true;
            i.isSelected = true;
          } else if (num === 0) {
            // 二级没有全选中的，判断下有没有选中的
            if (num2 === 0) {
              // 一个选中的都没有
              i.isAll = false;
              i.isSelected = false;
            } else {
              i.isAll = false;
              i.isSelected = true;
            }
          } else {
            // 部分选中
            i.isAll = false;
            i.isSelected = true;
          }
        }
      });
      // this.mockData = arr2;
      let arr = JSON.parse(JSON.stringify(this.qryCategoryByCodeTwo));
      arr[index] = item;
      this.qryCategoryByCodeTwo = [...arr];
    },
    cancel() {
      this.dialogVisible2 = false;
      this.$emit("update:dialogVisible", false);
    },
    determine() {
      let arr = this.filterSelectedWithoutChildren(this.mockData);
      let arr1 = this.mockData.filter(item => item.isSelected);
      if (arr1.length > 3) {
        this.$message({
          type: "warning",
          message: `最多只能选择3个一级类目`,
          offset: document.body.clientHeight / 2 - 50
        });
        return;
      }
      this.dialogVisible2 = false;
      this.$emit("update:dialogVisible", false);
      this.$emit("determine", arr);
    },
    filterSelectedWithoutChildren(items) {
      let result = [];
      function traverse(items) {
        for (const item of items) {
          if (
            item.isSelected === true &&
            (!item.children || item.children.length === 0)
          ) {
            result.push(item);
          }
          if (item.children && item.children.length > 0) {
            traverse(item.children);
          }
        }
      }
      traverse(items);
      return result;
    },

    // 初始化处理否全选和选中状态数据
    isAllList(arr1) {
      let arr = JSON.parse(JSON.stringify(arr1));
      arr.map(item1 => {
        if (item1.isSelected === true || item1.isSelected === "1") {
          // 选中
          item1.isSelected = true;
        } else {
          item1.isSelected = false;
          item1.isAll = false;
        }
        if (item1.children.length > 0) {
          // 有二级类目，循环
          let num2 = 0;
          item1.children.map(item2 => {
            if (item2.isSelected === true || item2.isSelected === "1") {
              // 选中
              item2.isSelected = true;
            } else {
              item2.isSelected = false;
              item2.isAll = false;
            }
            if (item2.children.length > 0) {
              // 有三级类目，循环
              let num3 = 0;
              item2.children.map(item3 => {
                if (item3.isSelected === true || item3.isSelected === "1") {
                  // 当前项选中
                  num3++;
                  item3.isSelected = true;
                } else {
                  item3.isSelected = false;
                }
              });
              if (num3 === item2.children.length) {
                item2.isAll = true;
                item2.isSelected = true;
                num2++;
              } else if (num3 === 0) {
                // 全部未选中
                item2.isAll = false;
                item2.isSelected = false;
              } else {
                // 部分选中
                item2.isAll = false;
                item2.isSelected = true;
              }
            }
          });
          if (num2 === item1.children.length) {
            item1.isAll = true;
          } else if (num2 === 0) {
            // 全部未选中
            item1.isAll = false;
          } else {
            // 部分选中
            item1.isAll = false;
          }
        }
      });
      return arr;
    },

    pushData() {
      if (this.defaultPitchOn.length > 0) {
        // 有默认缓存数据，不需要请求数据
        let arr = JSON.parse(JSON.stringify(this.defaultPitchOn));
        this.mockData = [...arr];
        console.log(this.mockData, "this.mockData");
        this.selectAllCategory(this.mockData[0], 0);
      } else {
        this.flag = true;
        let formData = {
          isShowLoading: true
          // agentId: this.agentId,
          // shopId: this.shopId
        };
        console.log(
          this.changeId,
          "this.changeIdthis.changeIdthis.changeIdthis.changeId"
        );
        if (this.changeId) {
          formData.changeId = this.changeId;
        }
        qryMatCatery100001Tree(formData)
          .then(res => {
            if (res.data.code === "0") {
              res.data.data = res.data.data.filter(item => {
                return item.categoryCode != 13;
              });

              let mockarr = this.isAllList(res.data.data);
              console.log(mockarr, "mockarrmockarrmockarr");
              mockarr.map(item => {
                item.firstCategoryCode = item.categoryCode;
                item.firstCategoryName = item.categoryName;
                if (item.children.length > 0) {
                  item.children.map(item1 => {
                    item1.firstCategoryCode = item.categoryCode;
                    item1.firstCategoryName = item.categoryName;
                    item1.secondCategoryCode = item1.categoryCode;
                    item1.secondCategoryName = item1.categoryName;
                    if (item1.children.length > 0) {
                      item1.children.map(item2 => {
                        item2.firstCategoryCode = item.categoryCode;
                        item2.firstCategoryName = item.categoryName;
                        item2.secondCategoryCode = item1.categoryCode;
                        item2.secondCategoryName = item1.categoryName;
                        item2.thirdCategoryCode = item2.categoryCode;
                        item2.thirdCategoryName = item2.categoryName;
                      });
                    }
                  });
                }
              });
              // this.defaultPitchOn.map((item) => {
              //   mockarr.map((e) => {
              //     if (item.categoryCodes.split(",")[0] === e.categoryCode) {
              //       e.children.push(item);
              //     }
              //   });
              // });
              mockarr.map(item => {
                item.children.map(e => {
                  if (e.categoryCodes) {
                    e.categoryCode = e.categoryCodes.split(",")[1];
                    e.categoryName = e.categoryNames.split(">")[1];
                    e.children = [];
                    setTimeout(() => {
                      e.categoryCodes
                        .split(",")[2]
                        .split("\\")
                        .map((r, ir) => {
                          let data = {};
                          data.categoryCode = r;
                          data.isSelected = true;
                          e.categoryNames
                            .split(">")[2]
                            .split("\\")
                            .map((t, it) => {
                              if (ir === it) {
                                data.categoryName = t;
                                e.children.push(data);
                                e.children = this.unique(e.children);
                              }
                            });
                        });
                    }, 10);
                  }
                });
              });
              this.mockData = mockarr;

              this.$emit("refdata", mockarr);
              this.selectAllCategory(mockarr[0], 0);
              console.log(
                this.mockData,
                "mockthis.mockDatathis.mockDatathis.mockDatathis.mockDataarr"
              );
            } else {
            }
            this.flag = false;
          })
          .catch(() => {
            this.flag = false;
          });
      }
    },

    // 获取二三级类目
    selectAllCategory(itemFirst, idx) {
      console.log(itemFirst, "itemFirst");
      let arr = JSON.parse(JSON.stringify(itemFirst.children));
      if (itemFirst.isSelected) {
        // 有选中的下级
        arr.map(e => {
          if (e.isSelected) {
            // 有选中的下级
            let checkList = [];
            e.children.map(item1 => {
              if (item1.isSelected) {
                checkList.push(item1.categoryCode);
              }
            });
            e.checkList = checkList;
          } else {
            e.checkList = [];
          }
        });
      } else {
        arr.map(e => {
          e.checkList = [];
          e.isSelected = false;
          e.isAll = false;
          e.children.map(item1 => {
            item1.isSelected = false;
          });
        });
      }
      this.qryCategoryByCodeTwo = [...arr];
      console.log(this.qryCategoryByCodeTwo, "this.qryCategoryByCodeTwo");
    },

    unique(arr, code) {
      // 根据唯一标识orderId来对数组进行过滤
      const res = new Map(); // 定义常量 res,值为一个Map对象实例
      // 返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
      return arr.filter(
        arr => !res.has(arr.categoryCode) && res.set(arr.categoryCode, 1)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.el-dialog-multi-checkbox-group /deep/ .el-dialog__body {
  min-height: 557px !important;
  max-height: 557px !important;
  height: 557px !important;
  overflow: hidden !important;
}

.el-dialog-multi-checkbox-group .el-aside .el-checkbox__label {
  line-height: 1;
  cursor: pointer !important;
}

.el-dialog-multi-checkbox-group .el-aside .el-checkbox__input {
  line-height: 1;
  height: 57%;
}

.el-dialog-multi-checkbox-group .el-aside .activeAll {
  background-color: #ffe8ea;
}

.el-dialog-multi-checkbox-group .el-aside .activeAll .el-checkbox__label p {
  color: #ff142f !important;
}

.el-dialog-multi-checkbox-group .check-box-tmpl {
  // display: -webkit-box;
  // display: -ms-flexbox;
  // display: flex;
  display: block;
  height: auto;
  overflow: hidden;
  padding: 0 10px;
}

.el-dialog-multi-checkbox-group .check-box-tmpl .el-checkbox__label {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  white-space: normal;
}

.el-dialog-multi-checkbox-group .check-box-tmpl .all {
  width: 190px;
  // border-right:1px solid #f1f1f1;
  box-sizing: border-box;
}

.el-dialog-multi-checkbox-group .check-box-tmpl .el-checkbox-group {
  // -webkit-box-flex: 3;
  // -ms-flex: 3;
  // flex: 3;
  width: calc(100% - 200px);
  min-height: 36px;
}

.el-dialog-multi-checkbox-group /deep/ .el-checkbox {
  margin-right: 0;
}
.el-dialog-multi-checkbox-group /deep/ .el-checkbox-group {
  // overflow: hidden;
}
.el-dialog-multi-checkbox-group /deep/ .child-checkbox {
  white-space: initial;
  border-left: 1px solid #f1f1f1;
  box-sizing: border-box;
  padding-left: 10px;
  .el-checkbox {
    margin-right: 20px;
  }
}
/deep/ #el-tooltip-7214.el-tooltip__popper.is-dark {
  display: none;
}
</style>
